export const FOCUSABLE_ELEMENTS = [
  'input',
  'select',
  'div[role="radio"].single-payway'
]
